import { render, staticRenderFns } from "./moduleEdit.vue?vue&type=template&id=5e70ce2e&scoped=true&"
import script from "./moduleEdit.vue?vue&type=script&lang=js&"
export * from "./moduleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70ce2e",
  null
  
)

export default component.exports